<template>
	<div class="panel panel__box" v-if="show">
		<div class="panel__section panel__section-left">
			<ul class="content-box">
				<li class="content-box__status content-box-secondary content-default" :class="`status-${booking.state}`">
					{{ $t(`booking.state.${booking.state}`) }}
				</li>
				<li class="content-box-primary content-box-primary-bold">{{ date.format('DD/MM') }}</li>
				<li class="content-box-primary content-box-primary">{{ date.format('dddd') }}</li>
				<li class="content-box-primary content-box-primary-bold">{{ date.format('H:mm') }}</li>
			</ul>
		</div>
		<div class="panel__section panel__section-right">
			<ul class="content-box">
				<li class="content-box-secondary content-default">{{ booking.barber.name }}</li>
				<li class="content-box-primary-bold">{{ firstService.name }}</li>
				<li class="content-box__services-secondary content-box-secondary content-default">
					<ul>
						<li v-for="(service, i) in booking.services" :key="i">{{ service.name }}</li>
					</ul>
				</li>
				<li class="content-box-secondary content-default">{{ $n(booking.price, 'currency') }}</li>
			</ul>
			<div class="icon__divider-small">
				<span class="icon icon__divider-outer">
					<span class="icon icon__divider-inner"></span>
				</span>
			</div>
			<div class="panel__controls">
				<span class="panel__controls-item content-box-secondary content-default" @click="detail">detail rezervace</span>
				<div
					class="divider__vertical-content content-box-secondary content-default"
					v-if="booking.can_user_cancel || booking.state === 'completed'"
				></div>
				<span class="panel__controls-item content-box-secondary content-default" v-if="booking.can_user_cancel" @click="cancelConfirm">
					zrušit rezervaci
				</span>
				<span class="panel__controls-item content-box-secondary content-default" v-if="booking.state === 'completed'" @click="again">
					opakovat rezervaci
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
	props: {
		data: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			show: false,
			booking: {},
			firstService: {},
		}
	},

	created() {
		this.booking = this._.cloneDeep(this.data)
		this.firstService = this.booking.services[0]
		this.booking.services = this._.drop(this.booking.services)
		this.show = true
	},

	computed: {
		date() {
			return this.$moment(this.booking.date)
		},
	},

	methods: {
		...mapMutations({ removeBookingData: 'booking/DEL_BOOK' }),
		...mapActions({
			bookingStart: 'booking/start',
			setService: 'booking/setService',
			setAddons: 'booking/setAddons',
			setBarber: 'booking/setBarber',
		}),
		detail() {
			this.$modal('components/booking', { data: this.data })
		},
		cancelConfirm() {
			this.$modal('components/bookingCancelConfirm', {}, { close: () => this.cancel() })
		},
		async cancel() {
			let { data } = await this.$http.delete(this.booking.cancel_url)
			this.booking = data
		},
		async again() {
			this.removeBookingData()

			try {
				await this.bookingStart()
				await this.setService(this.firstService.id)
				await this.setAddons(this._.map(this.booking.services, 'id'))
				await this.setBarber(this.booking.barber.id)
			} catch {
				null
			}
			this.$router.push({ name: 'booking' })
		},
	},
}
</script>

<style lang="scss" scoped></style>
